// API oficial G4 — wrapper mínimo sobre /api/rbac/*.
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/rbac`;

const client = axios.create({ withCredentials: true });

export async function listPermissions() {
  const { data } = await client.get(`${API}/permissions`);
  return data.permissions;
}

export async function listRoles() {
  const { data } = await client.get(`${API}/roles`);
  return data.roles;
}

export async function createRole(payload) {
  const { data } = await client.post(`${API}/roles`, payload);
  return data.role;
}

export async function listBranches() {
  const { data } = await client.get(`${API}/branches`);
  return data.branches;
}

export async function listEmployees() {
  const { data } = await client.get(`${API}/employees`);
  return data.employees;
}

export async function getEmployee(id) {
  const { data } = await client.get(`${API}/employees/${id}`);
  return data;
}

export async function updateRoles(id, role_names, reason) {
  const { data } = await client.patch(`${API}/employees/${id}/roles`, { role_names, reason });
  return data;
}

export async function addGrant(id, permission_id, reason) {
  const { data } = await client.post(`${API}/employees/${id}/grants`, { permission_id, reason });
  return data;
}

export async function removeGrant(id, permission_id, reason) {
  const { data } = await client.post(`${API}/employees/${id}/grants/remove`, { permission_id, reason });
  return data;
}

export async function addRevoke(id, permission_id, reason) {
  const { data } = await client.post(`${API}/employees/${id}/revokes`, { permission_id, reason });
  return data;
}

export async function removeRevoke(id, permission_id, reason) {
  const { data } = await client.post(`${API}/employees/${id}/revokes/remove`, { permission_id, reason });
  return data;
}

export async function updateBranchScope(id, scope, reason) {
  const { data } = await client.patch(`${API}/employees/${id}/branch-scope`, { scope, reason });
  return data;
}

export async function updateActive(id, is_active, reason) {
  const { data } = await client.patch(`${API}/employees/${id}/active`, { is_active, reason });
  return data;
}

export async function forcePasswordChange(id, reason) {
  const { data } = await client.post(`${API}/employees/${id}/force-password-change`, { reason });
  return data;
}

export async function restoreRecommended(id, reason) {
  const { data } = await client.post(`${API}/employees/${id}/restore`, { reason });
  return data;
}

export async function listAudit(limit = 50) {
  const { data } = await client.get(`${API}/audit`, { params: { limit } });
  return data.events;
}
